import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Container,
  CssBaseline,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { CustomTab, CustomTabs, TabPanel } from "../components-molecules";
import { theme } from "../constants/theme";
import { Verticals, Categories, Subcategories, UPCImports } from "../components-organisms";
import { setSelectedUpcEditorTab } from "../redux/actions/upcEditor";
import { useTranslation } from 'react-i18next';

const UpcEditor = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const value: number = useSelector(
    (state: any) => state.OrdersReducer.selectedTab
  );
  const dispatch = useDispatch();

  const handleChange = (_: any, newValue: any) => {
    dispatch(setSelectedUpcEditorTab(newValue));
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <div className={classes.headerTitle}>
          <Typography variant="h5" component="h5" color="textPrimary">
{t('admin.universalProductCatalogueEditor')}
          </Typography>
        </div>
        <Container className={classes.tabContainer}>
          <CustomTabs value={value} onChange={handleChange}>
            <CustomTab label={t('admin.imports')} textColor="primary" />
            <CustomTab label={t('admin.verticals')} />
            <CustomTab label={t('admin.categories')} />
            <CustomTab label={t('admin.subcategories')} />
          </CustomTabs>
        </Container>
        <TabPanel style={{ paddingTop: 0 }} value={value} index={0}>
          <UPCImports />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={value} index={1}>
          <Verticals />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={value} index={2}>
          <Categories />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={value} index={3}>
          <Subcategories />
        </TabPanel>
      </Container>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: 840,
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerTitle: {
    marginBottom: 8,
    paddingLeft: '24px'
  },
  tabContainer: {
    paddingLeft: "24px",
    paddingRight: "24px",
    backgroundColor: theme.palette.background.paper,
  },
  heading: {
    paddingLeft: "24px",
    marginBottom: "14px",
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  buttonSet: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "24px",
  },
});

export default UpcEditor;
